import { useEffect } from "react";

import { useAuthStore } from "@/client/stores/auth";

let sessionManager: any = null;

export const useSessionManager = () => {
  const user = useAuthStore((state) => state.user);

  useEffect(() => {
    // Only initialize session manager for logged-in users
    if (user && !sessionManager) {
      import("../utils/session-manager").then(({ SessionManager }) => {
        sessionManager = new SessionManager();

        // Make session manager available globally for the resume store
        (window as any).__sessionManager = sessionManager;
      });
    }

    // Cleanup on logout
    if (!user && sessionManager) {
      sessionManager.destroy();
      sessionManager = null;
      (window as any).__sessionManager = null;
    }

    return () => {
      // Cleanup on unmount
      if (sessionManager) {
        sessionManager.destroy();
        sessionManager = null;
        (window as any).__sessionManager = null;
      }
    };
  }, [user]);
};
